<div class="fulfillmentLanding seed-return-wrapper shippingAvailability">
  <div class="cppReturnsLandingPage">
    <!--<div class="row">
      <div class="col-md-10 col-lg-10">
        <h3>Shipping Availability Report</h3>
      </div>
      <div class="col-md-2 col-lg-2 text-right">
        <img src="../assets/icon/svg/manage-reports.svg" (click)="selectFilter()" />
        <a href="Javascript:void(0);" style="color: #0b3f54; padding:15px;" (click)="selectFilter()">MANAGE REPORTS</a>
      </div>
    </div>-->
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <app-filter [(optionsData)]="filterOptionsData" [filterData]="filter" [shippingAvailabilityList]="shippingAvailabilityList" [currentFilter]="currentFilter"
                    [isSearchButtonOutside]="true" [reportType]="8" [isReleaseOrderEnable]="isReleaseOrderEnable" [hasReleaseOrderAccess] ="hasReleaseOrderAccess"
                    (searchClick)="filterSearchClick($event)" (clearAllClick)="filterClearAllClick($event)" (selectFilterClick)="selectFilter($event)"
                    (addFilterClick)="addFilter($event)" (editFilterClick)="editFilter($event)"
                    (saveFilterClick)="save($event)" (exportClick)="export()" (emailDataClick)="emailData()" (releaseOrderClick)="releaseOrder()">
        </app-filter>
      </div>
      <!--<div class="col-lg-1 col-md-2 margin-t34 text-left">
        <button mat-raised-button class="btns xs-button xs-full-width export-button" [disabled]="(this.shippingAvailabilityList && this.shippingAvailabilityList.length <= 0) " (click)="export()">Export</button>
      </div>
      <div class="col-lg-1 col-md-2 margin-t34 text-left">
        <button mat-raised-button class="btns xs-button xs-full-width email-button" [disabled]="(this.shippingAvailabilityList && this.shippingAvailabilityList.length <= 0)" (click)="emailData()">Email</button>
      </div>-->
    </div>

    <div class="row">
      <div class="col-md-12 legend-outer">

        <div class="margin-t10">
          <div class="row">
            <div class="col-md-12">

              <div class="fulfill-top-sec">
                <div class="row listing-action-items">
                  <div class="col-sm-4">
                  </div>
                  <div class="col-xl-8 col-lg-8 col-md-8 text-right">
                    <div class="display-ib wAuto">
                      <mat-paginator #shippingAvailabilityPaginator [pageSize]="masterConstants.PAGE_SIZE" [pageSizeOptions]="masterConstants.PAGE_SIZE_OPTIONS"></mat-paginator>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 tableContainer">
                  <div class="tableContainerInner">
                    <table mat-table #shippingAvailabilityTable [dataSource]="shippingAvailabilityDataSource" multiTemplateDataRows matSort matSortDirection="desc" class="matTables productTable resultTable">
                      <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
                        <div *ngIf="column=='detail'">
                        <th mat-header-cell *matHeaderCellDef class="text-center accountName"></th>
                  </div>
                  <div *ngIf="column=='parentAccountNumber'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center accountName"> Parent Account </th>
                  </div>
                  <div *ngIf="column=='parentAccountName'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center accountName"> Parent Account Name </th>
                  </div>
                  <div *ngIf="column=='accountNumber'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center accountNumber"> Account </th>
                  </div>
                  <div *ngIf="column=='accountName'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center accountName"> Account Name </th>
                  </div>
                  <div *ngIf="column=='city'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center accountNumber"> City </th>
                  </div>
                  <div *ngIf="column=='state'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center accountNumber"> State </th>
                  </div>
                  <div *ngIf="column=='productLine'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center accountNumber"> Product Line </th>
                  </div>
                  <div *ngIf="column=='itemNumber'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center accountNumber"> Item Number </th>
                  </div>
                  <div *ngIf="column=='productDescription'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center accountNumber"> Product Description </th>
                  </div>
                  <div *ngIf="column=='packageSize'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center accountNumber"> Package Size </th>
                  </div>
                  <div *ngIf="column=='seedSize'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center accountNumber"> Seed Size </th>
                  </div>
                  <div *ngIf="column=='treatment'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center accountNumber"> Treatment </th>
                  </div>
                  <!--<div *ngIf="column=='eaUnits'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center accountNumber"> EA Units </th>
                  </div>
                  <div *ngIf="column=='eaModifiableUnits'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center accountNumber"> EA Modifiable Units </th>
                  </div>-->
                  <div *ngIf="column=='dealerOrderTotalQuantity'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center accountNumber"> Dealer Order Total Quantity </th>
                  </div>
                  <div *ngIf="column=='previouslyShippedAndScheduledQuantity'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center accountNumber"> Previously Shipped + Scheduled Quantity </th>
                  </div>
                  <div *ngIf="column=='dealerOrderOpenQuantity'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center action"> Dealer Order Open Quantity </th>
                  </div>
                  <div *ngIf="column=='availableToShipQuantity'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center transactionID"> Available To Ship Quantity </th>
                  </div>

                  <td mat-cell *matCellDef="let element; let i = dataIndex">
                    <div *ngIf="column=='detail' && !(element.dealerOrderOpenQuantity > 0 && element.availableToShipQuantity <= 0)" class="text-center">
                      <span><i (click)="showDetails($event, element)" [ngClass]="element.selected ? 'dropdownArrowOpen':'dropdownArrowClose'" class="fas fa-chevron-right"></i></span>
                    </div>
                    <div *ngIf="column=='parentAccountNumber'" class="text-center">

                      <p class="display-ib">{{element.parentAccountNumber}}</p>
                    </div>
                    <div *ngIf="column=='parentAccountName'" class="text-center">
                      <p>{{element.parentAccountName}}</p>
                    </div>
                    <div *ngIf="column=='accountNumber'" class="text-center">
                      <p>{{element.accountNumber}}</p>
                    </div>
                    <div *ngIf="column=='accountName'" class="text-center">
                      <p>{{element.accountName}}</p>
                    </div>
                    <div *ngIf="column=='city'" class="text-center">
                      <p>{{element.city}}</p>
                    </div>
                    <div *ngIf="column=='state'" class="text-center">
                      <p>{{element.state}}</p>
                    </div>
                    <div *ngIf="column=='productLine'" class="text-center">
                      <p>{{element.productLine}}</p>
                    </div>
                    <div *ngIf="column=='itemNumber'" class="text-center">
                      <p>{{element.dealerOrderItemNumber}}</p>
                    </div>
                    <div *ngIf="column=='productDescription'" class="text-center">
                      <p>{{element.productDescription}}</p>
                    </div>
                    <div *ngIf="column=='packageSize'" class="text-center">
                      <p>{{element.packageSize}}</p>
                    </div>
                    <div *ngIf="column=='seedSize'" class="text-center">
                      <p>{{element.seedSize}}</p>
                    </div>
                    <div *ngIf="column=='treatment'" class="text-center">
                      <p>{{element.treatment}}</p>
                    </div>
                    <!--<div *ngIf="column=='eaUnits'" class="text-center">
                      <p>{{element.eaUnits}}</p>
                    </div>
                    <div *ngIf="column=='eaModifiableUnits'" class="text-center">
                      <p>{{element.eaModifiableUnits}}</p>
                    </div>-->
                    <div *ngIf="column=='dealerOrderTotalQuantity'" class="text-center">
                      <p>{{element.dealerOrderTotalQuantity}}</p>
                    </div>
                    <div *ngIf="column=='previouslyShippedAndScheduledQuantity'" class="text-center">
                      <p>{{element.previouslyShippedAndScheduledQuantity}}</p>
                    </div>
                    <div *ngIf="column=='dealerOrderOpenQuantity'" class="text-center">
                      <p>{{element.dealerOrderOpenQuantity}}</p>
                    </div>
                    <div *ngIf="column=='availableToShipQuantity'" class="text-center">
                      <p>{{ element.availableToShipQuantity && element.availableToShipQuantity > 0 ? element.availableToShipQuantity : 0 }}</p>
                    </div>
                  </td>
                  </ng-container>
                  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                  <ng-container matColumnDef="expandedDetail">
                    <td mat-cell class="product-details p-0" *matCellDef="let element" [attr.colspan]="displayedColumns.length" [ngStyle]="element.selected ? '':{'display': 'none'}">
                      <div class="example-element-detail" [@detailExpand]="element && element.selected ? 'expanded' : 'collapsed'">
                        <table>
                          <thead>
                            <tr>
                              <th></th>
                              <th>BP Number</th>
                              <th>BP City</th>
                              <th>BP State</th>
                              <th>Available to Ship</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let branch of element.branchPlantDetails">
                              <td class="padding-t10">
                                <mat-checkbox class="custom-checkbox branchPlantCheckbox"
                                              *ngIf="element.availableToShipQuantity>0"
                                              [(ngModel)]="branch.isSelected"
                                              [checked]="ngModel"
                                              [disabled]="!hasReleaseOrderAccess"
                                              (change)="selectBPNumber(element, branch, $event)"> </mat-checkbox>
                              </td>
                              <td>{{branch.bpNumber}}</td>
                              <td>{{branch.bpCity}}</td>
                              <td>{{branch.bpState}}</td>
                              <td>{{branch.availableToShip}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
                  <tr mat-row *matRowDef="let element; columns: displayedColumns;"
                      [ngClass]="element.dealerOrderOpenQuantity > 0 && element.availableToShipQuantity <= 0 ? 'highlightRed' : ''"
                      class="example-element-row"
                      [class.example-expanded-row]="element && element.selected"></tr>
                  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                  </table>
                  <div *ngIf="shippingAvailabilityDataSource == undefined || shippingAvailabilityDataSource?.data.length == 0" class="noDataMsg">
                    <p>No Record Found.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  </div>
